export default __webpack_public_path__ + "static/media/busy-indicator.68c4e3a6.svg";